var map = {
	"./about1.webp": 9462,
	"./about2.jpg": 2578,
	"./about3.jpg": 4726,
	"./bajadas.png": 2321,
	"./bisagras.png": 2602,
	"./bloquetes.png": 4149,
	"./holux.png": 8961,
	"./insumos.png": 2783,
	"./kimey.png": 7866,
	"./maniguetas.png": 1714,
	"./mesas.png": 1197,
	"./neutralzone.png": 8727,
	"./remeras.png": 2764,
	"./shablones.png": 3186,
	"./tecnodas.png": 3846,
	"./vortex.png": 3584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;